import React, { Component } from 'react';
import axios from '~/axios';
import { Button, Row, Col } from 'antd';

import CourseList from '../components/courses/CourseList';
import AddCourseForm from '../components/courses/AddCourseForm';
import EditCourseForm from '../components/courses/EditCourseForm';

export default class Courses extends Component {
    constructor(props) {
        super(props);
        this.state = {
            courses: [],
            categories: [],
            showAddCoursesForm: false,
            showEditCourseForm: false,
            courseEditID: undefined,
            loading: false
        }
        this.showAddCourseForm = this.showAddCourseForm.bind(this);
        this.hideAddCourseForm = this.hideAddCourseForm.bind(this);
        this.showEditCourseForm = this.showEditCourseForm.bind(this);
        this.hideEditCourseForm = this.hideEditCourseForm.bind(this);
        this.handleAddCourse = this.handleAddCourse.bind(this);
        this.handleRemoveCourse = this.handleRemoveCourse.bind(this);
        this.handleEditCourse = this.handleEditCourse.bind(this);
        this.saveFormRef = this.saveFormRef.bind(this);
        this.editFormRef = this.editFormRef.bind(this);
        this.handleSetActiveCourse = this.handleSetActiveCourse.bind(this);
        // this.handleChange = this.handleChange.bind(this);
    }

    /**
     * Retrieves all courses currently in the database.
     */
    componentDidMount() {
        this.setState({ loading: true });
        axios.get("api/courses").then(response => {
            // console.log(response.data)
            this.setState({ loading: false, courses: response.data });
        }).catch(error => {
            console.error(error);
        });
        axios.get("api/course-categories").then(response => {
            // console.log(response.data.data)
            this.setState({ categories: response.data.data });
        }).catch(error => {
            console.error(error);
        });

    }

    /**
     * Shows the 'Add Session' form.
     */
    showAddCourseForm() {
        this.setState({ showAddCourseForm: true });
    }

    /**
     * Hides the 'Add Session' form.
     */
    hideAddCourseForm() {
        this.setState({ showAddCourseForm: false });
    }

    /**
     * Shows the 'Edit Course' form.
     */
    showEditCourseForm(id) {
        console.log("showing edit course form");
        console.log(id);
        this.setState({ courseEditID: id });
        const form = this.editForm.props.form;
        // console.log(form.getFieldsValue());
        let course = this.state.courses.find(element => {
            return element.courseID === id;
        });
        // console.log(course);
        form.setFieldsValue({
            title: course.title,
            description: course.description,
            targetAudience: course.targetAudience,
            day: course.day,
            type: course.type,
            active: course.active,
            course_category_id: course.course_category_id,
            // siteSpecific: course.siteSpecific,
        });
        this.setState({ showEditCourseForm: true });
    }

    /**
     * Hides the 'Edit Session' form.
     */
    hideEditCourseForm() {
        const form = this.editForm.props.form;
        form.resetFields();
        this.setState({ courseEditID: undefined });
        this.setState({ showEditCourseForm: false });
    }


    /**
     * Creates a new Course.
     */
    handleAddCourse() {
        const form = this.formRef.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            console.log(values);
            // let dateString = values.date.format('YYYY-MM-DD') + ' ';
            // values.startTime = dateString + values.startTime.format('HH:mm:ss');
            // values.endTime = dateString + values.endTime.format('HH:mm:ss');
            try {
                axios.post('/api/courses', values).then(response => {
                    this.handleChange(values.course);
                    form.resetFields();
                    this.setState({ showAddCourseForm: false });
                });
            } catch ( error ) {
                console.dir(error);
            }
        });
    }

    handleRemoveCourse(courseID) {
        console.log('removing submission from main dashboard component')
        let courses = this.state.courses;
        let index = courses.findIndex(element => {
            return element.courseID === courseID;
        });
        courses.splice(index, 1);
        this.setState({ courses: courses });
    }

    handleEditCourse() {
        console.log('save edited form')
        const courseID = this.state.courseEditID;
        const form = this.editForm.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            console.log(values);
            // let dateString = values.date.format('YYYY-MM-DD') + ' ';
            // values.startTime = dateString + values.startTime.format('HH:mm:ss');
            // values.endTime = dateString + values.endTime.format('HH:mm:ss');
            try {
                axios.patch('/api/courses/' + courseID, values).then(response => {
                    console.log(response)
                    this.handleChange();
                    this.hideEditCourseForm();
                }).catch(error => {
                    // TODO add utility function for displaying error modal
                    console.log(error)
                });

                // axios.post('/api/courses', values).then(response => {
                // 	this.handleChange(values.course);
                // 	form.resetFields();
                // 	this.setState({ showAddCourseForm: false });
                // });
            } catch ( error ) {
                console.dir(error);
            }
        });


    }

    handleSetActiveCourse(courseID, active) {
        console.log('update active status of course')
        try {
            axios.patch('/api/courses/' + courseID, {
                ...this.state.courses.find(x => x.courseID === courseID),
                active: active
            }).then(({ data }) => {
                console.log(data)

                let courses = this.state.courses;
                let index = courses.findIndex(object => {
                    return object.courseID === data.courseID;
                });
                courses[index].active = data.active;
                console.log(courses);
                this.setState({ courses: courses });
            }).catch(error => {
                console.log(error)
            });
        } catch ( error ) {
            console.dir(error);
        }

    }

    saveFormRef(formRef) {
        this.formRef = formRef;
    }

    editFormRef(formRef) {
        this.editForm = formRef;
    }

    /**
     * Retrieves a course's sessions when a course is selected.
     * @param {number} - The ID of the course to get sessions for.
     */
    handleChange(value) {
        axios.get("api/courses").then(response => {
            // console.log(response.data)
            this.setState({ courses: response.data });
        }).catch(error => {
            console.error(error);
        });
    }

    render() {
        return (
            <div className="container">
                <Row>
                    <Col span={ 12 }>
                        <h1>Courses</h1>
                    </Col>
                    <Col span={ 12 }>
                        <Button type="primary" onClick={ this.showAddCourseForm } style={ { float: 'right' } }>Add
                            Course</Button>
                    </Col>
                </Row>
                <CourseList loading={ this.state.loading } data={ this.state.courses }
                            showSendDialog={ this.showSendDialog } handleRegister={ this.handleRegister }
                            handleUnregister={ this.handleUnregister } handleRemoveCourse={ this.handleRemoveCourse }
                            handleEditCourse={ this.showEditCourseForm }
                            handleSetActiveCourse={ this.handleSetActiveCourse }/>
                <AddCourseForm
                    wrappedComponentRef={ this.saveFormRef }
                    visible={ this.state.showAddCourseForm }
                    onCancel={ this.hideAddCourseForm }
                    onOk={ this.handleAddCourse }
                    categories={ this.state.categories }
                />
                <EditCourseForm
                    id={ this.state.courseEditID }
                    wrappedComponentRef={ this.editFormRef }
                    visible={ this.state.showEditCourseForm }
                    onCancel={ this.hideEditCourseForm }
                    onOk={ this.handleEditCourse }
                    categories={ this.state.categories }
                />
            </div>
        );
    }
}
